import { useContext } from "react";
import UserContext from "../../contexts/userContext";

import { MsalAuth } from "./1_MsalAuth";
import { NavigationBar } from "./2_NavigationBar";
import { DocumentList } from "./5_DocumentList";
import { ChatPageLayout } from "../chat/0_ChatPageLayout";
import { InfoModal } from "./3_InfoModal";
import { Tour } from "./4_Tour";

export const PageLayout = () => {
    const { userContext } = useContext(UserContext);
    const isAuthenticated = userContext && userContext.account;
    const doShowDocs = isAuthenticated && !userContext.document;
    const doShowChat = isAuthenticated && userContext.document;

    return (
        <>
            <MsalAuth />
            <NavigationBar />
            <InfoModal />
            {isAuthenticated && <Tour />}
            {doShowDocs && <DocumentList />}
            {doShowChat && <ChatPageLayout />}
        </>
    );
};